import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { useDragConstraint, Cylinder, ObjectProps, Box } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 500,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [19, 1.5, 10], mass: 300, position: [0, 0.75, 0], type: 'Box' },

      { args: [0.5, 0.5, 1.5], mass: 150, position: [-8, -0.75, -3.5], type: 'Cylinder' },
      { args: [0.5, 0.5, 1.5], mass: 150, position: [0, -0.75, -3.5], type: 'Cylinder' },
      { args: [0.5, 0.5, 1.5], mass: 150, position: [8, -0.75, -3.5], type: 'Cylinder' },
      { args: [0.5, 0.5, 1.5], mass: 150, position: [-8, -0.75, 3.5], type: 'Cylinder' },
      { args: [0.5, 0.5, 1.5], mass: 150, position: [0, -0.75, 3.5], type: 'Cylinder' },
      { args: [0.5, 0.5, 1.45], mass: 150, position: [8, -0.75, 3.5], type: 'Cylinder' }, // memo: 実際短いw
    ], 
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box position={[0, 0.75, 0]} args={[19, 1.5, 10]} />

      <Cylinder position={[-8, -0.75, -3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
      <Cylinder position={[0, -0.75, -3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
      <Cylinder position={[8, -0.75, -3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
      <Cylinder position={[-8, -0.75, 3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
      <Cylinder position={[0, -0.75, 3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
      <Cylinder position={[8, -0.75, 3.5]} args={[0.5, 0.5, 1.5, 8]} color="#2a2a2a" />
    </group>
  );
};
